import styled from 'styled-components'
import { charcoal } from '@sukiai/components/lib/colors'

const InvisibleContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`

const Container = styled.div`
  overflow-y: auto;
  min-width: 500px;
  width: 60vw;
  background: white;
  color: ${charcoal};
  z-index: 2000;
  border-radius: 5px 5px 0 0;
  height: 92vh;
`

const HeaderActions = styled.div`
  position: absolute;
  top: 0;
  height: 50px;
  width: 100%;
  background-color: #f0f4ef;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;

  h4 {
    font-weight: 600;
  }
`

const Button = styled.button.attrs({
  type: 'button'
})`
  border: none;
  outline: none;
  padding: 0px;
  background: transparent;
  cursor: pointer;
  color: rgb(65, 117, 5);
  font-size: 14px;
  font-family: "Open sans";

  &:disabled {
    color: gray;
  }
`

const ScriptNameInput = styled.input.attrs({
  readonly: (props) => props.readOnly
})`
  width: 60%;
  font-family: "Open Sans";
  height: 40px;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.03);
  border: none;
  outline: none;
  margin: auto;
  margin-bottom: 8px;
  padding: 0 10px;
  text-align: center;
  font-size: 16px;
  cursor: ${(props) => (props.readOnly ? 'default' : 'auto')};

  &:focus::placeholder {
    color: transparent;
  }
`

const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
  width: 100%;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
  }
  position: relative;
`

const SectionOptions = styled.div`
  position: absolute;
  left: 0;
  width: 420px;
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 350px;
  overflow: scroll;
  div {
    padding: 10px;
    width: 100%;

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
  z-index: 9999;

  * {
    box-sizing: border-box;
  }
`

const Platter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 420px;
  border-radius: 5px;
  font-family: "Open Sans";
  padding: 10px;
  cursor: pointer;
  position: relative;
  margin-bottom: 12px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }

  .label {
    margin: 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
  }

  .section-name {
    font-size: 16px;
    color: #000000;
    margin: 0;
    margin-top: 5px;
    font-weight: 600;
  }
`

const SectionBlock = styled.div`
  position: relative;
  width: 100%;
`

const ScriptNameTip = styled.div`
  font-size: 14px;
  color: rgb(0, 0, 0, 0.5);
`

export {
  InvisibleContainer,
  Container,
  HeaderActions,
  Button,
  ScriptNameInput,
  Body,
  SectionOptions,
  Platter,
  SectionBlock,
  ScriptNameTip
}
